import { render, staticRenderFns } from "./MasterLayoutComponent.vue?vue&type=template&id=6c8e6308&"
import script from "./MasterLayoutComponent.vue?vue&type=script&lang=ts&"
export * from "./MasterLayoutComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports